import { useCallback } from "react"

export const useAdministrationPath = () => {
  return useCallback((subPath = "") => `/administration${subPath}`, [])
}
